import React, { FC, Fragment } from 'react';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { StyledToggleButton } from 'components/shared/styled-toggle-button/styled-toggle-button.component';

type LabExceptionsProps = {
    handleExceptionSelection: (exceptions: Record<string, boolean>) => void;
    labExceptions: string[];
    savedExceptions: Record<string, boolean>;
    dataTest?: string;
};
const LabExceptions: FC<LabExceptionsProps> = ({
    handleExceptionSelection,
    labExceptions,
    savedExceptions,
    dataTest,
}: LabExceptionsProps) => {
    const { t: translate } = useTranslation(['orders']);

    const handleContent = (labException: string) => {
        const selectedExceptions = { ...savedExceptions };
        selectedExceptions[labException] = !selectedExceptions[labException];
        handleExceptionSelection(selectedExceptions);
    };

    return (
        <Fragment>
            <Box mt={1}>
                <ToggleButtonGroup value={savedExceptions} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {labExceptions.map((labException: string) => {
                        return (
                            <StyledToggleButton
                                key={labException}
                                value={labException}
                                sx={(theme) => ({
                                    ...(savedExceptions[labException] && {
                                        background: theme.palette.primary.main,
                                        color: '#fff !important',
                                        '&:hover': { background: theme.palette.primary.main },
                                    }),
                                })}
                                onClick={() => handleContent(labException)}
                                data-test={`${dataTest}-content-${labException}`}
                            >
                                {translate(labException)}
                            </StyledToggleButton>
                        );
                    })}
                </ToggleButtonGroup>
            </Box>
        </Fragment>
    );
};

export default LabExceptions;
